import { render } from "./ModalObservarHistorico.vue?vue&type=template&id=5f44abd1&scoped=true"
import script from "./ModalObservarHistorico.vue?vue&type=script&lang=js"
export * from "./ModalObservarHistorico.vue?vue&type=script&lang=js"

import "./ModalObservarHistorico.vue?vue&type=style&index=0&id=5f44abd1&scoped=true&lang=css"

import exportComponent from "/home/mauro/proyectos/vue-genesis-observability/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f44abd1"]])

export default __exports__